module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_15.b7c863b5.png";